import React, { FC } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { messages } from '../../../../../i18n';
import { LabelInput } from './inputs/LabelInput';
import { SizeInput } from './inputs/SizeInput';
import { CustomPresetInputRefs } from './index';

const Root = styled.div`
  flex: 1;
  display: flex;
  margin: 0 ${globalTheme.spacing.xs};
`;

const TextFieldWrapper = styled.div<{ size: 'long' | 'short' }>`
  flex: ${(props) => props.size === 'long' ? 2 : 1};

  &:not(:last-child) {
    margin-right: ${globalTheme.spacing.xs};
  }
`;

export interface InputsProps {
  inputRefs: CustomPresetInputRefs,
}

export const Params: FC<InputsProps> = ({ inputRefs }) => {
  const { formatMessage } = useIntl();

  return (
    <Root>
      <TextFieldWrapper size="long">
        <LabelInput
          inputRef={inputRefs.label}
        />
      </TextFieldWrapper>
      <TextFieldWrapper size="short">
        <SizeInput
          placeholder={formatMessage(messages['section.resizeAndCrop.presets.customPreset.widthPlaceholder'])}
          dimension="width"
          inputRef={inputRefs.width}
        />
      </TextFieldWrapper>
      <TextFieldWrapper size="short">
        <SizeInput
          placeholder={formatMessage(messages['section.resizeAndCrop.presets.customPreset.heightPlaceholder'])}
          dimension="height"
          inputRef={inputRefs.height}
        />
      </TextFieldWrapper>
    </Root>
  );
};
